import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Globals } from '@anduin/config';
import { Observable } from 'rxjs';

export interface MintResponse {
  /**
   * Signed Zendesk Messaging `loginUser` JWT for the current staff session, or `null`
   * when the session cannot be identified (no staff claim, missing or inactive staff
   * row) — in which case the widget stays anonymous.
   */
  jwt: string | null;
}

/**
 * Obtains a Zendesk Messaging JWT for the authenticated firm-portal user from artengine.
 *
 * Addressed like every other artengine call — `actionEngineUrl` + the secure-firm prefix —
 * so it picks up the `Bearer`/`Tenant` pair that artengine's `FirmTokenHandlerInterceptor`
 * requires from the interceptor rule that already covers those calls.
 */
@Injectable({ providedIn: 'root' })
export class ChatbotApiService {
  private readonly http = inject(HttpClient);
  private readonly globals = inject(Globals);

  mintMessagingJwt(): Observable<MintResponse> {
    return this.http.post<MintResponse>(`${this.globals.actionEngineUrl}/api/secure/firm/v1/chatbot/mint`, {});
  }
}
